import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useQuery } from '@tanstack/react-query'
import { observer } from 'mobx-react'
import moment from 'moment'
import React from 'react'
import { useIntl } from 'react-intl'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import {
  isDealer,
  isDealerOperator,
  roles,
} from '../../../../../services/AccountService'
import { getComments } from '../../../../../services/ApiService'
import { RequestType } from '../../SingleRequest/types/Request.type'

interface NewCommentsAccProps {
  request: RequestType
}

function NewCommentsAcc({ request }: NewCommentsAccProps) {
  const intl = useIntl()

  const { data } = useQuery({
    queryKey: ['get-request-comments', request.id],
    queryFn: () => getComments(request.id),
  })

  if (!data?.length) return null

  return (
    // @ts-ignore
    <CustomAccordion
      summary={intl.formatMessage({ id: 'Комментарии' })}
      defaultOpenState
    >
      {data
        ?.slice()
        .reverse()
        .map((comment: any, i: any) => {
          const { text, date, authorName, role } = comment
          const authorRole = roles[role as 0]

          return (
            <Box
              sx={{
                padding: '8px 8px 4px 12px',
                borderRadius: '4px',
                marginTop: i ? '2px' : 0,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                position: 'relative',
                border: '1px solid #EBE8E8',
                boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.25)',
              }}
              key={date}
            >
              <Typography
                variant={'body1'}
                sx={{
                  marginBottom: '4px',
                  fontWeight: '600',
                  fontSize: '12px',
                }}
              >
                {isDealer() || isDealerOperator()
                  ? authorRole
                  : authorName || authorRole}
              </Typography>
              <Typography
                variant={'body1'}
                sx={{ wordBreak: 'break-word', fontSize: '14px' }}
              >
                {text}
              </Typography>
              <Typography sx={{ fontSize: '12px', textAlign: 'right' }}>
                {moment(date).format('DD.MM.YYYY, HH:mm')}
              </Typography>
            </Box>
          )
        })}
    </CustomAccordion>
  )
}

export default observer(NewCommentsAcc)
